import React, { useRef } from 'react'

import {
  Grid, Dialog,
  DialogTitle as MuiDialogTitle, Typography,
  IconButton, DialogContent as MuiDialogContent, Paper,
  Table, TableHead,
  TableRow, TableCell, TableBody, TableContainer
} from '@material-ui/core'

import AnnouncementIcon from '@material-ui/icons/Announcement'
import { Close as CloseIcon } from '@material-ui/icons'

import { withStyles } from '@material-ui/core/styles'

import moment from 'moment'

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow)

const LoginInfoList = ({ classes, loginInfo, supervisor, toggleModal, open, actionType }) => {
  const componentRef = useRef()

  const modalToggle = () => {
    toggleModal()
  }

  /* Currently removing entry from loginInfo once returned */
  // const checkLogoutTimestamp = (logoutTimestamp = 0, loginDuration = '') => {
  //   if (logoutTimestamp > moment().unix()) {
  //     return '---'
  //   } else {
  //     return loginDuration ? `${loginDuration}` : moment.unix(logoutTimestamp).format('MM/DD/YYYY LT')
  //   }
  // }

  return (
    <>
      <Dialog open={open} onClose={modalToggle} className='filterModal' fullWidth maxWidth='sm'>
        <MuiDialogTitle disableTypography>
          <Grid item container direction='row' justify='space-between'>
            <Grid item xs={10}>
              <Typography
                variant='h4'
                color='primary'
                classes={{ colorPrimary: classes.greenText }}
                className='font-weight-bold'
              >
                Login Report for {supervisor}
              </Typography>
            </Grid>

            <Grid item xs={2}>
              <IconButton aria-label='close' className={classes.closeButton} onClick={modalToggle}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>

        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <Grid container justify='center' direction='row' className='mt-3'>
            <Grid container direction='column' justify='center'>
              <Grid container direction='row'>
                <Grid container item direction='column' justify='flex-end' xs={12} className={classes.tableContainer}>
                  <Paper elevation={2} className={classes.tablePaper}>
                    <Grid
                      container
                      direction='column'
                      justify='center'
                      className='px-3 w-100 py-3 mx-auto my-auto'
                      spacing={2}
                    >
                      {
                        loginInfo.length > 0
                          ? (
                            <TableContainer>
                              <Table className={classes.table} size='small' aria-label='users-table'>
                                <TableHead>
                                  <TableRow>
                                    <TableCell className={`${classes.tableHeadText} unselectable`}>Logged In</TableCell>
                                    <TableCell className={`${classes.tableHeadText} unselectable`}>Logged Out</TableCell>
                                    <TableCell className={`${classes.tableHeadText} unselectable`}>Login Duration</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {loginInfo.map((login, index) => (
                                    <StyledTableRow key={index}>
                                      <TableCell
                                        align='left'
                                        className={classes.tableText}
                                      >
                                        {moment.unix(login.createdAt).format('MM/DD/YYYY LT')}
                                      </TableCell>

                                      <TableCell
                                        align='left'
                                        className={classes.tableText}
                                      >
                                        {/* {checkLogoutTimestamp(login.endedAt)} */}
                                        {moment.unix(login.endedAt).format('MM/DD/YYYY LT')}
                                      </TableCell>

                                      <TableCell
                                        align='left'
                                        className={classes.tableText}
                                      >
                                        {/* {checkLogoutTimestamp(login.endedAt, login.loginDuration)} */}
                                        {login.loginDuration}
                                      </TableCell>
                                    </StyledTableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          ) : (
                            <Grid item container direction='row' justify='center' alignItems='center'>
                              {/* <Loader type='ThreeDots' color='#97b557' height={150} width={150} /> */}
                              <Paper
                                className='mx-auto'
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginTop: '10vh',
                                  height: '20rem',
                                  width: '30rem',
                                  padding: '1.5rem',
                                  backgroundColor: '#F5F5F5'
                                }}
                              >
                                <Grid item container direction='column' xs={12}>
                                  <Grid item container direction='row' justify='center'>
                                    <AnnouncementIcon
                                      style={{
                                        fontSize: '4rem',
                                        color: 'grey',
                                        marginBottom: '1rem'
                                      }}
                                    />
                                  </Grid>
                                  <Grid item container direction='row' justify='center'>
                                    <Typography
                                      style={{ fontWeight: 'bold', color: 'grey', fontSize: '1.5rem' }}
                                    >
                                      No Login Info Found For {supervisor}
                                    </Typography>
                                  </Grid>
                                  <Grid item container direction='row' justify='center'>
                                    <Typography>There is currently no login info associated with this supervisor during the given time frame. Please try again.</Typography>
                                  </Grid>
                                </Grid>
                              </Paper>
                            </Grid>
                          )
                      }
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>

          </Grid>
          <Grid item container direction='column' ref={componentRef} />
        </MuiDialogContent>
      </Dialog>
    </>
  )
}

export default LoginInfoList
